document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.inline-rew-slider');
  container.classList.add('swiper');

  const slidesWrapper = container; 
  const slides = Array.from(container.querySelectorAll('.inline-rew-slide'));
  
  const wrapper = document.createElement('div');
  wrapper.classList.add('swiper-wrapper');
  slides.forEach(slide => {
    slide.classList.add('swiper-slide');
    wrapper.appendChild(slide);
  });
  container.innerHTML = '';
  container.appendChild(wrapper);



  const swiper = new Swiper('.inline-rew-slider', {
    loop: true,
    centeredSlides: true,
    speed: 600,
    navigation: {
      nextEl: '#inline-rew-next',
      prevEl: '#inline-rew-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      }
    },
    on: {
        init: function () {
            autoSlideTimeout = setTimeout(() => {
                this.slideNext();
            }, 3000);
        }
        
    }
  });


  swiper.on('slideChange', () => {
    document.querySelectorAll('.inline-rew-slide').forEach(s => s.classList.remove('rew-slide-active'));
    const active = swiper.slides[swiper.activeIndex];
    if (active) active.classList.add('rew-slide-active');
  });
});